import { PriceModelView } from "./priceModelView";


export default PriceModelView